import { throttle, type Unsubscribe } from '@amazon/vinyl-util'
import { getNetworkInformation, noop } from '@amazon/vinyl-util'

export function isProbablyMobileData(): boolean {
    const networkInformation = getNetworkInformation()
    if (!networkInformation) return false // Can't detect

    return (
        networkInformation.type === 'cellular' ||
        ['2g', '3g', 'slow-2g'].includes(networkInformation.effectiveType)
    )
}

export function onIsProbablyMobileDataChange(
    callback: (isProbablyMobileData: boolean) => void
): Unsubscribe {
    let currentValue = isProbablyMobileData()
    callback(currentValue)
    const networkInformation = getNetworkInformation()
    if (!networkInformation) return noop
    const onChange = throttle(
        () => {
            const newValue = isProbablyMobileData()
            if (currentValue !== newValue) {
                currentValue = newValue
                callback(newValue)
            }
        },
        10,
        { trailing: true }
    )
    networkInformation.addEventListener('change', onChange)
    return () => networkInformation.removeEventListener('change', onChange)
}
